import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { DailyLabel, DailyArrowButton } from 'components/Calendar'

const DailyCalendar: FC = React.memo(() => {
  return (
    <div className={styles.calendar__daily}>
      <DailyArrowButton label={'前日'} type={'prev'} />
      <DailyLabel />
      <DailyArrowButton label={'翌日'} type={'next'} />
    </div>
  )
})

export default DailyCalendar
